import { render, staticRenderFns } from "./ConfirmDeleteShiftDialog.vue?vue&type=template&id=160cb7c9&scoped=true"
import script from "./ConfirmDeleteShiftDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteShiftDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteShiftDialog.vue?vue&type=style&index=0&id=160cb7c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160cb7c9",
  null
  
)

export default component.exports